// extracted by mini-css-extract-plugin
module.exports = {"rootArea":"ProfessionEditingPage_rootArea__2owlS","managingArea":"ProfessionEditingPage_managingArea__DkRK-"};